import $ from 'jquery'

const LINK_ATTR = 'data-modal-content'
const CONFIG_ATTR = 'data-modal-config'
const REMOVE_DELAY = 300

export function initialise() {
  $(document).on('click', `[${LINK_ATTR}]`, event => {
    event.preventDefault()
    const url = $(event.currentTarget).attr(LINK_ATTR)
    const config = parseConfig($(event.currentTarget).attr(CONFIG_ATTR))
    initModal({ url, ...config })
  })
}

function parseConfig(configString) {
  try {
    const parsed = JSON.parse(configString)
    if (typeof parsed === 'object') {
      return parsed
    }
  } catch (e) {}
  return {}
}

function initModal(config) {
  const $modal = $(`<div class="modal-container">
    <aside class="modal ${config.modalClass || ''}">
      <button type="button" class="button-text button-icon button-square button-s color-primary close-button" data-close-modal>
        <svg width="24" height="24"><use xlink:href="/assets/glyphs/glyphs.svg?cachebust=2024#close-thin"></use></svg>
      </button>
      <div class="modal-inner ${config.modalInnerClass || ''}">
        <div class="modal-body ${config.modalBodyClass || ''}" data-modal-body></div>
      </div>
    </aside>
  </div>`)

  const $modalBody = $('[data-modal-body]', $modal)

  $modal.on('click', '[data-close-modal]', () => close($modal))
  $modal.on('mouseup', event => {
    if (event.target === event.currentTarget) {
      event.stopPropagation()
      close($modal)
    }
  })

  $('body').append($modal)

  $modalBody.load(config.url, () => {
    $modalBody.trigger('ajax.replace')
    open($modal)
  })
}

function open($modal) {
  $modal.addClass('open')
}

function close($modal) {
  $modal.removeClass('open')
  setTimeout(() => $modal.remove(), REMOVE_DELAY)
}
